module.exports = __webpack_public_path__ + "static/media/network-wired.da71c13a.svg";